import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class SupplierReferenceService extends BaseReferenceService {
  constructor() {
    super('SupplierReference');
  }

  get(): Observable<IdDescription[]> {
    console.log('A supplier search should be used instead of a dropdown');
    return super.get();
  }

  getManifestShippers(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetManifestShippers`);
  }

  getManifestShippersKey(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetManifestShippersKey`);
  }

  getShippers(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetShippers`);
  }

  getShippersKey(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetShippersKey`);
  }

  getAgents(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetAgents`);
  }
}
